export const GET_POST_TAGS = 'post_tag/GET_POST_TAGS';



// WEBPACK FOOTER //
// ./src/redux/PostTags/constants.js